import { GridContainer, Icon, Label, useDeviceSize } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { ConfigurationLink } from './Styles';

type Props = {
  route: string;
  linkLabel: string;
  title: string;
  linkId?: string;
  idTitle?: string;
  templateColumns?: string;
};

export const GoBackHeader = ({
  route,
  title,
  linkLabel,
  linkId,
  idTitle,
  templateColumns,
}: Props) => {
  const { t } = useTranslation();
  const { isMobile } = useDeviceSize();

  const isConfigPage = title === 'Configuration';

  return (
    <GridContainer
      gridTemplateColumns={templateColumns || '1fr 1fr 1fr'}
      alignItems="center"
    >
      <ConfigurationLink
        to={route}
        data-test={linkId || 'go-back-button'}
        id={linkId || 'go-back-button'}
      >
        <Icon iconName="CaretLeft" size="32" color="blue400" />
        {!isMobile && (
          <Label
            as="span"
            fontSize={isMobile ? '12' : '14'}
            semibold
            color="blue400"
          >
            {t(linkLabel)}
          </Label>
        )}
      </ConfigurationLink>
      <Label
        as="h1"
        fontSize={isMobile ? (isConfigPage ? '16' : '12') : '32'}
        semibold
        textAlign="center"
        id={idTitle}
        testId={idTitle}
      >
        {t(title)}
      </Label>
    </GridContainer>
  );
};
